var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("QueryForm"),
      _vm._v(" "),
      _vm.resultsVisible
        ? _c("QuerySummary", {
            staticClass: "cf-panel cf-panel-lg",
            attrs: { id: "summary" },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("Debug", [
        _c("div", [
          _c("div", [_vm._v("Full query: ")]),
          _c("pre", [_vm._v(_vm._s(_vm.debugQuery))]),
        ]),
      ]),
      _vm._v(" "),
      _c("Results", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.resultsVisible,
            expression: "resultsVisible",
          },
        ],
        attrs: { id: "results" },
      }),
      _vm._v(" "),
      _vm.pageGuideEnabled ? _c("PageGuide") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }